import { ca } from '@cian/analytics';
import { getAnalyticsSiteType } from '../utils/analytics';
import { EPaymentMethodType } from '../types/redux/paymentMethods';
import { EPaymentInitSource } from '../types/redux/checkout';
import { ANALYTICS_PAYMENT_METHODS_MAP } from '../constants/analytics';

interface IParams {
  paymentInitSource: EPaymentInitSource;
  paymentMethodType: EPaymentMethodType;
}

export const trackCancelButtonClick = (params: IParams) => {
  const { paymentInitSource, paymentMethodType } = params;

  const label = ANALYTICS_PAYMENT_METHODS_MAP[paymentMethodType];

  ca('eventSite', {
    name: 'oldevent',
    category: paymentInitSource,
    action: 'Click_widget_payment_cancel',
    label,
    page: {
      siteType: getAnalyticsSiteType(),
    },
  });
};
